import http from '@/utils/http';

/**
 * 首页核心指标-汇总数-lhx
 */
export const getHomePageCore = (data) => {
    return http({
        url: `/api-lcrm/homePage`,
        method: 'post',
        data
    });
};
/**
 * 获取当前角色list-yjl
 */
export const getUserRoleList = (data) => {
    return http({
        url: `/api-lcrm/homePage/getUserRole`,
        method: 'post',
        data
    });
};
/**
 * 获取排行榜列表-lhx
 */
export const getRankinglist = (data) => {
    return http({
        url: `/api-lcrm/income/rankingList`,
        method: 'post',
        data
    });
};
/**
 * 获取责任制汇总数据-xsh
 */
export const getRespCollect = (data) => {
    return http({
        url: `/api-lcrm/respCollect`,
        method: 'post',
        data
    });
};
/**
 * 获取责任制-版本下来框数据-xsh
 */
export const getRespVersionList = (data) => {
    return http({
        url: `/api-lcrm/respVersionList`,
        method: 'post',
        data
    });
};
/**
 * 获取责任制-明细弹窗数据-xsh
 */
export const getCumulativeScoreList = (data) => {
    return http({
        url: `/api-lcrm/cumulativeScoreList`,
        method: 'post',
        data
    });
};

/**
 * 获取责任制-查看责任制明细数据-hcf
 */
export const getCumulativeScoreDetail = (data) => {
    return http({
        url: `/api-lcrm/resp/details/page`,
        method: 'post',
        data
    });
};
/**
 * 获取客户列表-lhx
 */
export const getMyCusomterList = (data) => {
    return http({
        url: `/api-lcrm/myCustomer/page`,
        method: 'post',
        data
    });
};
/**
 * 获取商机列表-yjl
 */
export const getOpportunityList = (data) => {
    return http({
        url: `/api-lcrm/opportunity/homePage`,
        method: 'post',
        data
    });
};
/**
 * 获取搜索列表-yjl
 */
export const getSearchList = (data) => {
    return http({
        url: `/api-lcrm/homePage/globalSearch`,
        method: 'post',
        data
    });
};
/**
 * 收入概览-年 cjy
 */
export const getIncomePandectYear = (data) => {
    return http({
        url: `/api-lcrm/homePage/income/incomePandectYear`,
        method: 'post',
        data
    });
};
/**
 * 收入概览-月 cjy
 */
export const getIncomePandectMonth = (data) => {
    return http({
        url: `/api-lcrm/homePage/income/incomePandectMonth`,
        method: 'post',
        data
    });
};
/**
 * 收入概览-年-趋势图 cjy
 */
export const getIncomeHistoryYear = (data) => {
    return http({
        url: `/api-lcrm/homePage/income/incomeHistoryYear`,
        method: 'post',
        data
    });
};
/**
 * 收入概览-月-趋势图 cjy
 */
export const getIncomeHistoryMonth = (data) => {
    return http({
        url: `/api-lcrm/homePage/income/incomeHistoryMonth`,
        method: 'post',
        data
    });
};
/**
 * 商机概览(达成+规模) cjy
 */
export const getOpportunityPandect = (data) => {
    return http({
        url: `/api-lcrm/homePage/opportunity/opportunityPandect`,
        method: 'post',
        data
    });
};
/**
 * 商机概览(达成+规模) cjy
 */
export const getOpportunityBusinessType = (data) => {
    return http({
        url: `/api-lcrm/homePage/opportunity/opportunityBusinessType`,
        method: 'post',
        data
    });
};

/**
 * 商机状态（销售状态占比(规模)） cjy
 */
export const getOpportunityStatusRatio = (data) => {
    return http({
        url: `/api-lcrm/homePage/opportunity/opportunityStatusRatio`,
        method: 'post',
        data
    });
};
/**
 * 逾期应收概-年 cjy
 */
export const getOverduePandectYear = (data) => {
    return http({
        url: `/api-lcrm/homePage/overdue/overduePandectYear`,
        method: 'post',
        data
    });
};
/**
 * 逾期应收概-月 cjy
 */
export const getOverduePandectMonth = (data) => {
    return http({
        url: `/api-lcrm/homePage/overdue/overduePandectMonth`,
        method: 'post',
        data
    });
};
/**
 * 用户数据权限接口 xsh
 */
export const queryUserDataAuth = (data) => {
    return http({
        url: `/api-lcrm/homePage/queryUserDataAuth`,
        method: 'post',
        data
    });
};
/**
 * 获取所有分公司 xsh
 */
export const queryAllCompanyList = (params) => {
    return http({
        url: `/api-mdm/esCompany/popCompany`,
        method: 'get',
        params
    });
};
/**
 * 获取所有部门
*/
export const getCrmUserPage = (params) => {
    return http({
        url: `/api-lcrm/crmUser/page`,
        method: 'get',
        params
    });
};
/**
 * 获取所有分公司 -xsh
 */
export const getCompanyByAreaList = (data) => {
    return http({
        url: `/api-lcrm/homePage/company/escoCompanyNo`,
        method: 'post',
        data
    });
};
/**
 * 获取合同明细 -rzq
 */
export const getHomePageContract = (data) => {
    return http({
        url: `/api-lcrm/contract/info/authPage/home`,
        method: 'post',
        data
    });
};
/**
 * 根据片区获取分公司- 个人级-xsh
 */
export const getPersonalCompanyByArea = (data) => {
    return http({
        url: `/api-lcrm/homePage/company/escoCompanyNoPersonal`,
        method: 'post',
        data
    });
};
/**
 * 提成分配接口-rzq
 */
export const getHomepageCustomerManagerArchivePage = (data) => {
    return http({
        url: `/api-lcrm/customer/manager/archive/page/home`,
        method: 'post',
        data
    });
};
/**
 * 提成分配接口-wy
 */
export const getHomepageIncomeFilterOptions = (data) => {
    return http({
        url: `/api-lcrm/homePageMore/income/incomeFilterOptions`,
        method: 'post',
        data
    });
};
/**
 * 获取大专司-个人
 * @param {*} data
 * @returns
 */
export const queryBigProfessionalCompany = (data) => {
    return http({
        url: `/api-lcrm/homePage/personal/queryBigProfessionalCompany`,
        method: 'post',
        data
    });
};
/**
 * 获取客户服务指标-客户KPI及客诉-ylx
 * @param {*} data
 * @returns
 */
export const getCustomerComplaint = (data) => {
    return http({
        url: `/api-lcrm/homePage/customer/kpiAndMajorComplaints`,
        method: 'post',
        data
    });
};
/**
 * 获取客户服务指标-客户满意度及工单ylx
 * @param {*} data
 * @returns
 */
export const getCustomerSatisfactionOrder = (data) => {
    return http({
        url: `/api-lcrm/homePage/customer/investigationAndOrder`,
        method: 'post',
        data
    });
};
